function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0078 64.0156H29.8164C28.8867 59.4734 24.8625 56.0469 20.0547 56.0469H16.0703C11.2625 56.0469 7.23828 59.4734 6.30859 64.0156H4.11719C3.01484 64.0156 2.125 64.9055 2.125 66.0078C2.125 67.1102 3.01484 68 4.11719 68H32.0078C33.1102 68 34 67.1102 34 66.0078C34 64.9055 33.1102 64.0156 32.0078 64.0156ZM64.7461 4.18359C64.0555 3.85156 63.232 3.94453 62.6344 4.42266C57.3352 8.65938 50.4953 8.65938 45.1961 4.42266C39.432 -0.199219 32.2336 -0.85 26.0312 2.36406V35.0492C31.2109 31.3703 37.6656 31.5164 42.7125 35.5539C46.1125 38.2766 50.0172 39.6312 53.9219 39.6312C57.8266 39.6312 61.718 38.2633 65.1312 35.5539C65.6094 35.1688 65.875 34.5977 65.875 34V5.97656C65.875 5.20625 65.4367 4.51562 64.7461 4.18359ZM18.0625 0C15.8578 0 14.0781 1.77969 14.0781 3.98438V52.0625H22.0469V3.98438C22.0469 1.77969 20.2672 0 18.0625 0Z",
  fill: "url(#paint0_linear_105_9)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_105_9",
  x1: 2.125,
  y1: 34,
  x2: 65.875,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.b32380ca.svg";
export { ForwardRef as ReactComponent };